import { FileUploadService } from './file-upload.service';
import { IconSelectorComponent } from './icon-selector/icon-selector.component';
import { TrustedusersComponent } from './trustedusers/trustedusers.component';
import { AnothersolutionwrapperComponent } from './anothersolutionwrapper/anothersolutionwrapper.component';
import { SolutionwrapperComponent } from './solutionwrapper/solutionwrapper.component';
import { PdftoolComponent } from './pdftool/pdftool.component';
import { HeadersectionComponent } from './headersection/headersection.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import {
  Component,
  ViewChild,
  AfterViewInit,
  input,
  OnInit,
  Input,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload/file-upload.component'; // Import the standalone component
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TermsNConditionsComponent } from './terms-n-conditions/terms-n-conditions.component';
import { PrivacyNPolicyComponent } from './privacy-n-policy/privacy-n-policy.component';
import { BlogToolComponent } from './blog-tool/blog-tool.component';
import { Meta, Title } from '@angular/platform-browser';
import { ConfigService } from './../app/config-service.service'; // Import the service
import { Inject, Injectable, PLATFORM_ID, Optional } from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { SchemaService } from './schema.service';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonModule,
    FileUploadComponent,
    DocumentUploadComponent,
    SolutionwrapperComponent,
    HeaderComponent,
    TrustedusersComponent,
    FooterComponent,
    HeadersectionComponent,
    PdftoolComponent,
    AnothersolutionwrapperComponent,
    IconSelectorComponent,
    LoginComponent,
    RegisterComponent,
    TermsNConditionsComponent,
    PrivacyNPolicyComponent,
    BlogToolComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements AfterViewInit, OnInit {
  // title = 'pdfconverter';
  @ViewChild(DocumentUploadComponent)
  documentUploadComponent!: DocumentUploadComponent;
  showComponents: boolean = true;
  isWebLink: boolean = false;
  iconIdentifierRequest: string = '';
  isLoginPage!: boolean;
  isRegisterPage!: boolean;
  currentPath: string = '';
  isLandingPage!: boolean;
  isLandingDetailsPage!: boolean;
  termsPage!: boolean;
  privacyPage!: boolean;
  blogPage!: boolean;
  metaTitle: string = '';
  metaDescription: string = '';
  metaKeyword: string = '';
  BASE_URL: string = '';
  IsTools!: boolean;
  schemaJson: string = '';

  //BASE_URL = 'https://localhost:7033/api'; // Set your base URL here
  //BASE_URL = 'https://pdfconverterapi.thepdfleader.com/api'; // Set your base URL here

  constructor(
    private fileUploadService: FileUploadService,
    private router: Router,
    private metaService: Meta,
    private titleService: Title,
    private configService: ConfigService,
    private schemaService: SchemaService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) private request: any,
  ) {
    this.BASE_URL = configService.getApiUrl();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        if (url.length > 1 && url.endsWith('/')) {
          const trimmedUrl = url.replace(/\/$/, '');
          this.router.navigateByUrl(trimmedUrl);
        }
      }
    });
  }

  private endpointsUrl: { [key: string]: string } = {
    htmltoimage: 'HtmltoImage/convert-html-to-image',
    wordtopng: 'Newwordtopng/convertwordtoimage',
    watermark: 'WatermarkPdf/AddWatermarkAndSign',
    unlock: 'unlockpdf/unlock',
    protect: 'Protectpdf/protect',
    merge: 'mergepdf/merge',
    split: 'pdfsplit/split',
    pdftoword: 'NewPdftoWord/ConvertPdfToWord',
    htmltopdf: 'HtmltoPdf/convert-html-file',
    pdftoimage: 'NewPdftoImage/ConvertToImages',
    imagetopdf: 'ImageToPdf/generate-image-pdf',
    wordtopdf: 'Newwordtopdf/ConvertWordToPdf',
    pdftoexcel: 'PdfToExcel/extract-text',
    exceltopdf: 'NewExceltoPdf/convert-excel-to-pdf',
    ocr: 'NewOCRService/PerformOcr',
    compress: 'PdfCompression/compress',
    pptxtopdf: 'PowerPointToPdf/ConvertToPdf',

    // Add more icons and their corresponding endpoints here
  };
  ngOnInit(): void {
    // Get the current route path

    console.log('URL');
    console.log('Current URL123:', this.router.url);

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd), // Only listen for NavigationEnd
      )
      .subscribe(() => {
        this.getLastRouteSegment(); // Extract the last segment once navigation is complete
      });
  }
  getCurrentUrl(): string {
    if (isPlatformServer(this.platformId) && this.request) {
      // On server, use the request url
      console.log('Current URL111:', this.request.url);
      return this.request.url;
    } else {
      // On client, use Angular Router url
      console.log('Current URL222:', this.router.url);
      return this.router.url;
    }
  }

  setCanonicalUrl(url: string) {
    if (isPlatformServer(this.platformId)) {
      let link: HTMLLinkElement | null = this.document.querySelector(
        "link[rel='canonical']",
      );
      if (!link) {
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        this.document.head.appendChild(link);
      }
      link.setAttribute('href', url);
    }
  }
  getLastRouteSegment(): void {
    const currentUrl = this.router.url; // Get the full URL from the router
    //const currentUrl = this.getCurrentUrl();
    console.log('Current URL:', this.router.url); // Log the current URL

    const url = this.router.url;

    const segments = currentUrl.split('/'); // Split by "/"
    //const filteredSegments = segments.filter(segment => segment.length > 0); // Filter out empty strings
    const filteredSegments = url.split('/').filter((x) => x);
    // Get the last segment if available
    if (filteredSegments.length > 0) {
      this.currentPath = filteredSegments[filteredSegments.length - 1];

      // this.updateSchema(this.currentPath);
    } else {
      this.titleService.setTitle(
        'PDF Tools to Merge, Split and Convert | The PDF Leader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Merge PDFs, split files, and convert PDFs to Word, PNG, or HTML. Remove passwords, add watermarks, and manage PDFs easily—free with The PDF Leader!',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'merge pdf free, split pdf online, from pdf to doc, word to pdf, remove password from pdf, open protected pdf, word to png conversion',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/');
        this.document.head.appendChild(link);
      }
      this.isLandingPage = true;
      this.updateSchema('');
    }

    if (this.currentPath == 'pdf-merge') {
      this.titleService.setTitle(
        'Merge PDF Online Free | Combine PDF Files (No Sign-Up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Merge PDF files online for free with ThePDFLeader. Fast, secure, easy to use and free PDF merger. No sign-up needed to combine PDF files instantly.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'merge pdf free, combine pdf files, merge pdf documents, merge files into one pdf, combine pdf files online, merge pdf pages, merge all pdf into one, merge pdf files, merge pdf files free',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-merge');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-merge');
        this.document.head.appendChild(link);

      }
       this.updateSchema(this.currentPath);
      this.onMenuIconSelected('merge');
    } else if (this.currentPath == 'pdf-split') {
      this.titleService.setTitle(
        'Split PDF Online Free | Extract PDF File (No Sign-Up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Split PDF online free with ThePDFLeader. Fast, secure, and easy to use. No sign-up needed to extract PDF file online or extract PDF pages.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'split pdf file, split pdf online free, extract pages from pdf online, split pdf pages online, split pdf documents online free, pdf file separator online, online pdf file separator, cut pdf free online, pdf cutter online free',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-split');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-split');
        this.document.head.appendChild(link);
      }
      this.updateSchema(this.currentPath);
      this.onMenuIconSelected('split');
    } else if (this.currentPath == 'unlock-pdf') {
      this.titleService.setTitle(
        'Unlock PDF Online | Free PDF Password Remover (No Sign-Up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Fast & free unlock PDF online tool. Remove PDF password securely, no sign-up required. Access your locked PDFs in just seconds.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'unlock PDF, PDF unlock tool, remove PDF restrictions, PDF password removal, access locked PDFs, online PDF unlocking, PDF tools',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/unlock-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/unlock-pdf');
        this.document.head.appendChild(link);
      }
      this.updateSchema(this.currentPath);
      this.onMenuIconSelected('unlock');
    } else if (this.currentPath == 'protect-pdf') {
      this.titleService.setTitle(
        'Protect PDF Online | Add Password to PDF (No Sign-Up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Secure your documents with fast PDF protection. Protect PDF online for free, no sign-up. Easily add password to PDF at ThePDFLeader.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'protect PDF, PDF protection tool, secure PDF, PDF password protection, restrict PDF access, safeguard PDF documents, online PDF security',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/protect-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/protect-pdf');
        this.document.head.appendChild(link);
      }
       this.updateSchema(this.currentPath);
      this.onMenuIconSelected('protect');
    } else if (this.currentPath == 'watermark-pdf') {
      this.titleService.setTitle(
        'Watermark PDF Online | Add Watermark to PDF (No Sign-Up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Watermark PDF online instantly with our free tool. Add watermark to PDF securely, no sign-up required. Fast, simple, and unlimited usage. Perfect online PDF watermark adder.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'watermark PDF, PDF watermark tool, add watermark to PDF, customize PDF watermarks, secure PDF documents, online PDF watermarking, brand PDF files',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/watermark-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/watermark-pdf');
        this.document.head.appendChild(link);
      }
       this.updateSchema(this.currentPath);
      this.onMenuIconSelected('watermark');
    } else if (this.currentPath == 'ocr-pdf-image') {
      this.titleService.setTitle(
        'PDF OCR Online Free | Make PDF Searchable - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'ThePDFLeader offers PDF OCR online free. Upload, process, and convert PDF to searchable PDF with unlimited usage, secure conversion, and zero sign-up.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'OCR PDF, OCR tool, convert PDF to text, image to text, scanned document conversion, editable PDF, online OCR, extract text from images',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/ocr-pdf-image');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/ocr-pdf-image');
        this.document.head.appendChild(link);
      }
       this.updateSchema(this.currentPath);
      this.onMenuIconSelected('ocr');
    } else if (this.currentPath == 'html-to-image') {
      this.titleService.setTitle(
        'HTML To Image | Convert HTML to PNG (No Sign-Up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Free and fast HTML to Image tool. Convert HTML to PNG without login. ThePDFLeader offers secure, no-limit html-to-image conversion for all.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'HTML to image, convert HTML to image, online image converter, web page to image, screenshot HTML, HTML conversion tool, capture web content',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/html-to-image');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/html-to-image');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('htmltoimage');
    } else if (this.currentPath == 'pdf-to-word') {
      this.titleService.setTitle(
        'PDF to Word Converter Online Free (No Sign-Up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Need to convert PDF to Word free? Use ThePDFLeader – a fast, secure, and free PDF to Word converter online with no registration required.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'PDF to Word, convert PDF to Word, PDF conversion tool, editable Word document, online PDF to Word, PDF to DOCX, extract text from PDF',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-to-word');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-to-word');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('pdftoword');
    } else if (this.currentPath == 'html-to-pdf') {
      this.titleService.setTitle(
        'Convert HTML to PDF Free Online (No Sign-Up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Need to convert HTML to PDF free? ThePDFLeader is your secure, no sign-up, unlimited-use HTML to PDF online tool. Create PDFs from HTML in seconds!',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'HTML to PDF, convert HTML to PDF, online PDF converter, web page to PDF, PDF creation tool, save HTML as PDF, document conversion',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/html-to-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/html-to-pdf');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('htmltopdf');
    } else if (this.currentPath == 'pdf-to-excel') {
      this.titleService.setTitle(
        'PDF To Excel Converter Online | Free PDF To XLS (No Sign-up) - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Free & secure PDF to Excel online converter. Convert PDF to XLS fast, no sign-up needed. Best tool to convert PDF to Excel with 100% accuracy.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'PDF to Excel, convert PDF to Excel, PDF conversion tool, extract data from PDF, online PDF to Excel, PDF to XLSX, spreadsheet converter',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-to-excel');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-to-excel');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('pdftoexcel');
    } else if (this.currentPath == 'word-to-png') {
      this.titleService.setTitle(
        'Free Word to PNG | Word to Image Converter Online - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Convert Word to PNG online instantly with our free Word to image converter. Fast, secure, no sign-up needed. Convert DOC to PNG or DOCX to PNG with ultimate ease.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'Word to PNG, DOCX to PNG, convert Word to PNG online, Word file to image, free Word to PNG converter, high-quality PNG conversion, extract images from DOCX',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/word-to-png');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/word-to-png');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('wordtopng');
    } else if (this.currentPath == 'excel-to-pdf') {
      this.titleService.setTitle(
        'Convert Excel to PDF Online - Fast, Accurate & Free | The PDF Leader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Convert your Excel spreadsheets to PDF effortlessly with ThePDFLeader. Fast, secure, and accurate conversion for professional document sharing!',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'Excel to PDF, convert Excel to PDF, XLS to PDF, online Excel conversion, PDF creation tool, spreadsheet to PDF, secure PDF conversion',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/excel-to-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/excel-to-pdf');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('exceltopdf');
    } else if (this.currentPath == 'pdf-to-image') {
      this.titleService.setTitle(
        'Convert PDF to Image Free - Quick Online Tool',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Transform PDF files into high-quality images online for free. Convert to JPG, PNG, and other formats easily and securely.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'pdf online free,convert pdf to image free,convert pdf to doc for free,pdf to online free,convert file to img,pdf to image file conversion,online convert pdf to image free.pdf files images',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-to-image');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/pdf-to-image');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('pdftoimage');
    } else if (this.currentPath == 'image-to-pdf') {
      this.titleService.setTitle(
        'Convert JPG to PDF Free | Image to PDF Converter Online - ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Looking for the best way to convert JPG to PDF? Try ThePDFLeader’s JPG to PDF converter free. Fast, safe, no signup required, and unlimited usage. Create PDFs instantly from your JPG images.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'free image to pdf,online image to pdf,convert image to file,convert pic to pdf online free,image to high quality pdf,pdf to image file conversion,pic to pdf file,image to pdf free online,convert file to pdf online free',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/image-to-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/image-to-pdf');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('imagetopdf');
    } else if (this.currentPath == 'word-to-pdf') {
      this.titleService.setTitle(
        'Convert Word to PDF Online - Fast, Reliable & Free | The PDF Leader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Convert your Word documents to PDF easily with ThePDFLeader. Fast, secure, and accurate conversion for seamless document sharing. Try it now!',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'Word to PDF, convert Word to PDF, DOC to PDF, online PDF converter, create PDF from Word, high-quality PDF conversion, Word document to PDF',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/word-to-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/word-to-pdf');
        this.document.head.appendChild(link);
      }
       this.updateSchema(this.currentPath);
      this.onMenuIconSelected('wordtopdf');
    } else if (this.currentPath == 'compress-pdf') {
      this.titleService.setTitle(
        'Free PDF Compressor | Reduce PDF Size Online- ThePDFLeader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'ThePDFLeader PDF compressor helps you shrink PDFs instantly. Free, no signup, unlimited usage. Try our free PDF compressor online now.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'shrink pdf,compress pdf without losing quality,compress large pdf,reduce pdf file,reduce document size,reduce pdf image size',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/compress-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/compress-pdf');
        this.document.head.appendChild(link);
      }
       this.updateSchema(this.currentPath);
      this.onMenuIconSelected('compress');
    } else if (this.currentPath == 'pptx-to-pdf') {
      this.titleService.setTitle(
        'PPT/PPTX to PDF Online | Free PPT to PDF Converter- ThePDF Leader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Free, unlimited, and secure PPTX to PDF converter. Instantly convert PowerPoint to PDF for free. No signup needed, your PPT file converts to PDF in seconds.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'powerpoint presentation pdf,power point in pdf,power point into pdf,make pdf from powerpoint,power point to pdf,make powerpoint pdf',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/pptx-to-pdf');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/pptx-to-pdf');
        this.document.head.appendChild(link);
      }
 this.updateSchema(this.currentPath);
      this.onMenuIconSelected('pptxtopdf');
    } else if (this.currentPath == 'terms-n-conditions') {
      this.titleService.setTitle(
        'Terms and Conditions - Service Use & Privacy Policy | The PDF Leader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Read the terms and conditions for using ThePDFLeader services. Understand your rights and responsibilities when using our PDF conversion tools.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'terms and conditions, ThePDFLeader terms, usage policy, service agreement, user agreement, PDF service terms, legal terms',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/terms-n-conditions',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/terms-n-conditions',
        );
        this.document.head.appendChild(link);
      }

      this.termsPage = true;
      this.isLandingPage = false;
    } else if (this.currentPath == 'privacy-n-policy') {
      this.titleService.setTitle(
        'Privacy Policy - Your Data Protection & Rights | The PDF Leader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn how ThePDFLeader protects your privacy. Read our privacy policy to understand data collection, usage, and your rights while using our services.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'privacy policy, ThePDFLeader privacy, data protection, user privacy rights, information security, data collection practices, privacy statement',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/privacy-n-policy',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/privacy-n-policy',
        );
        this.document.head.appendChild(link);
      }

      this.privacyPage = true;
      this.isLandingPage = false;
    } else if (this.currentPath == 'blog') {
      this.titleService.setTitle(
        'Essential PDF Management: Master Conversion, Editing & Document Optimization',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Get the latest insights and tools for PDF conversion, editing, and secure document management. Discover how to streamline your document workflows, enhance productivity, and utilize powerful PDF solutions.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'PDF management, PDF conversion tools, PDF editing tips, document workflow optimization, secure PDF handling, PDF compression solutions, productivity with PDFs, digital document management',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/blog');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/blog');
        this.document.head.appendChild(link);
      }

      this.blogPage = true;
      this.isLandingPage = false;
    } else if (this.currentPath == 'tools') {
      this.titleService.setTitle(
        'ThePDFLeader.com – Free Online PDF Tools for Merge, Convert, Protect & More',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Discover ThePDFLeader.com – your all-in-one online PDF solution. Merge, split, compress, protect, watermark, and convert PDFs to Word, Excel, Images, or HTML. Fast, secure, and free tools for all your document needs.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'ThePDFLeader, PDF tools, merge PDF, split PDF, compress PDF, convert PDF to Word, convert PDF to Excel, PDF to Image, image to PDF, HTML to PDF, HTML to Image, PPTX to PDF, Word to PDF',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/tools');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/tools');
        this.document.head.appendChild(link);
      }
      this.IsTools = true;
      this.isLandingPage = false;
    } else if (this.currentPath == 'how-to-copy-text-from-pdf') {
      this.titleService.setTitle(
        'How to Copy Text from PDF? Step-by-Step Guide (5 Solutions)',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Step-by-step guide to copy text from a PDF in any situation. Learn 5 proven methods for normal, scanned, and locked PDF files.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'copy text from PDF, extract text from PDF, copy from scanned PDF, OCR PDF to text, copy text from image PDF, copy from locked PDF (with permission), unlock PDF for copying (with permission),',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/how-to-copy-text-from-pdf',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/how-to-copy-text-from-pdf',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'what-is-ocr-pdf') {
      this.titleService.setTitle(
        'What is OCR PDF and How Does It Work? | The PDF Leader',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn OCR PDF technology, how it works, types, benefits & uses. Convert scanned files into searchable & editable PDFs easily. Yes, it matches standards.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'OCR PDF, Normal PDF, scanned PDF, searchable PDF, editable PDF, OCR software, document digitization, PDF text recognition',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/what-is-ocr-pdf',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/what-is-ocr-pdf',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'unlock-a-pdf-file-easily') {
      this.titleService.setTitle('Unlock PDF File Easily | Step-by-Step Guide');

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn how to unlock PDF files quickly with online tools. Follow this step-by-step guide to remove password restrictions and access your documents easily.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'PDF unlock tool, how to unlock PDF, access locked PDF, remove restrictions from PDF, decrypt PDF file, unlock secured PDF, open password protected PDF',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/unlock-a-pdf-file-easily',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/unlock-a-pdf-file-easily',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'how-to-extract-pages-from-pdf') {
      this.titleService.setTitle(
        'Split PDF Online | Extract Pages from PDF Easily',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn how to split PDF files and extract pages online in seconds. Use a free Split PDF tool to manage, share, and organise your documents quickly and securely.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'PDF page extractor, divide PDF file, separate PDF pages, manage PDF documents, organize PDF online, split and share PDF',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/how-to-extract-pages-from-pdf',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/how-to-extract-pages-from-pdf',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'merge-pdf-file-to-one-file') {
      this.titleService.setTitle(
        'Merge PDF Files Online | Combine Multiple PDFs Easily',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn how to merge PDF files into one document. Use free online tools to combine multiple PDFs quickly, securely, and without any installation.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'PDF merger tool, join PDF documents, combine multiple PDFs, free PDF merger, merge PDF securely, online PDF combiner, create single PDF',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/merge-pdf-file-to-one-file',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/merge-pdf-file-to-one-file',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'remove-pdf-password-online') {
      this.titleService.setTitle('How to Remove Password Protection from PDF');

      this.metaService.updateTag({
        name: 'description',
        content:
          'Unlock password-protected PDFs instantly with ThePDFLeader. Free, secure, and fast online PDF unlock tool. No installation or signup needed.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'remove password from PDF, unlock PDF, PDF password remover, unlock password protected PDF, remove PDF password online,',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/remove-pdf-password-online',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/remove-pdf-password-online',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'convert-pdf-to-excel-online') {
      this.titleService.setTitle('How to Convert PDF to Excel Online');

      this.metaService.updateTag({
        name: 'description',
        content:
          'Convert PDF to Excel online in seconds. Free, secure, and accurate PDF to Excel converter. No signup or installation—just upload, convert, and download.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'PDF spreadsheet converter, unlock PDF tables to Excel, how to convert PDF to Excel online, convert scanned PDF to Excel free',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/convert-pdf-to-excel-online',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/convert-pdf-to-excel-online',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'combine-pdf-file-free') {
      this.titleService.setTitle(
        'Combine PDF Files Free — Fast & Secure Online PDF Merge Tool',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Merge multiple PDF files into one instantly. Use our free PDF merge tool to combine documents online — secure, no installation, and works on all devices.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'combine pdf files free, merge pdf, pdf merge online free, combine documents, free pdf tools, merge pdf files online, pdf file merger, merge multiple pdfs, online pdf joiner, thepdfleader pdf merge',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/combine-pdf-file-free',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/combine-pdf-file-free',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'convert-word-to-png') {
      this.titleService.setTitle(
        'Best Way to Convert Word to PNG | Simple Word to Image Converter',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn the best way to convert Word to PNG without losing quality. Explore simple online tools, step-by-step tips, and reliable doc to PNG conversion methods.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'word to image converter, word to png, convert word to png, doc to png converter, doc to png, convert docx to png, word file to png',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/convert-word-to-png',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/convert-word-to-png',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'journey-of-pdf') {
      this.titleService.setTitle(
        'Journey of PDF: From Project Camelot to Global Document Standard',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Discover how PDF evolved from Adobe’s Project Camelot into the world’s most trusted document format. Learn its history, features, and why PDFs matter today.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'history of pdf, project camelot, inventor of pdf, john warnock pdf, pdf format evolution, pdf standard iso 32000, portable document format',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/journey-of-pdf',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/journey-of-pdf',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'pdf-files-without-software') {
      this.titleService.setTitle(
        'What Is the Most Efficient Way to Merge PDF Files Without Software | Free Online PDF Merge Tool',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn the most efficient way to merge PDF files without installing software. Discover secure, fast, and free online PDF merge tools and how to combine multiple PDFs effortlessly.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'merge pdf, combine pdf files, pdf merge tool, merge pdf online, combine pdf free, merge pdf without software, free pdf merger',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/pdf-files-without-software',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/pdf-files-without-software',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'convert-excel-to-pdf') {
      this.titleService.setTitle(
        'What Is the Most Efficient Way to Merge PDF Files Without Software | Free Online PDF Merge Tool',
      );

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn how to convert Excel to PDF easily using built-in options or online tools. Preserve formatting, secure data, and share professional PDFs in minutes.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'convert excel to pdf, excel to pdf online, excel to pdf converter, how to convert excel file to pdf, save excel as pdf, export excel to pdf, online excel to pdf tool',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/convert-excel-to-pdf',
        );
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(
          'href',
          'https://www.thepdfleader.com/convert-excel-to-pdf',
        );
        this.document.head.appendChild(link);
      }
      this.blogPage = false;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-pdf-split') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-pdf-split',
      });
      this.metaTitle = 'PDF Split Tool Online | Split PDFs Easily & Securely';
      this.metaDescription =
        'Split PDF files effortlessly with our free online tool. Extract specific pages or split large PDFs into smaller files while keeping your data secure.';
      this.metaKeyword =
        'PDF split, split PDF files, extract PDF pages, online PDF splitter, free PDF split tool, secure PDF split, easy PDF splitting';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-html-to-image') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-html-to-image',
      });
      this.metaTitle =
        'HTML to Image Converter | Convert HTML to Images Online';
      this.metaDescription =
        'Convert HTML to high-quality images effortlessly with our online tool. Supports PNG, JPG, and more formats. Fast, free, and easy-to-use solution.';
      this.metaKeyword =
        'HTML to image, convert HTML to image, HTML to PNG, HTML to JPG, online HTML to image tool, free HTML to image converter, HTML snapshot tool';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-pdf-to-word') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-pdf-to-word',
      });
      this.metaTitle =
        'PDF to Word Converter | Convert PDFs to Editable Word Files';
      this.metaDescription =
        'Convert PDF files to editable Word documents effortlessly. Use our free and secure PDF to Word converter for accurate and fast file conversion.';
      this.metaKeyword =
        'PDF to Word, convert PDF to Word, PDF to DOC, online PDF to Word converter, free PDF to Word tool, editable Word from PDF, PDF to DOCX';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-html-to-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-html-to-pdf',
      });
      this.metaTitle = 'HTML to PDF Converter | Convert HTML to PDF Online';
      this.metaDescription =
        'Convert HTML files or URLs to PDF easily with our free online tool. Maintain formatting and styles in high-quality PDFs. Fast, secure, and reliable.';
      this.metaKeyword =
        'HTML to PDF, convert HTML to PDF, online HTML to PDF tool, free HTML to PDF converter, HTML to PDF online, generate PDF from HTML, HTML to PDF maker';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-unlock-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-unlock-pdf',
      });
      this.metaTitle = 'Unlock PDF Online | Remove PDF Password Securely';
      this.metaDescription =
        'Unlock password-protected PDF files easily with our secure online tool. Remove restrictions and access your PDFs instantly. Free and user-friendly.';
      this.metaKeyword =
        'unlock PDF, remove PDF password, unlock protected PDF, PDF password remover, free unlock PDF tool, online PDF unlocker, decrypt PDF file';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-protect-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-protect-pdf',
      });
      this.metaTitle =
        'Protect PDF Online | Secure Your PDF Files with Password';
      this.metaDescription =
        'Secure your PDF files with passwords using our free online tool. Protect sensitive information and prevent unauthorized access to your documents.';
      this.metaKeyword =
        'protect PDF, add password to PDF, secure PDF online, encrypt PDF, PDF password protection, free PDF protector, online PDF security tool';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-watermark-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-watermark-pdf',
      });
      this.metaTitle = 'Watermark PDF Online | Add Text or Image Watermarks';
      this.metaDescription =
        'Add text or image watermarks to your PDF files effortlessly. Use our free online tool to protect your documents with customizable watermark options.';
      this.metaKeyword =
        'watermark PDF, add watermark to PDF, PDF watermark tool, text watermark PDF, image watermark PDF, free watermark PDF online, secure PDF watermarking';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-pdf-to-excel') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-pdf-to-excel',
      });
      this.metaTitle =
        'PDF to Excel Converter | Convert PDFs to Editable Excel';
      this.metaDescription =
        'Convert PDF files to editable Excel spreadsheets effortlessly. Use our free and accurate PDF to Excel converter for seamless data extraction.';
      this.metaKeyword =
        'PDF to Excel, convert PDF to Excel, PDF to XLS, PDF to XLSX, online PDF to Excel tool, free PDF to Excel converter, extract data from PDF';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-word-to-png') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-word-to-png',
      });
      this.metaTitle =
        'Word to PNG Converter | Convert Word Documents to Images';
      this.metaDescription =
        'Convert Word documents to PNG images effortlessly with our free online tool. Maintain quality and formatting in high-resolution images.';
      this.metaKeyword =
        'Word to PNG, convert Word to image, DOC to PNG, DOCX to PNG, Word to image converter, online Word to PNG tool, free Word to image converter';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-excel-to-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-excel-to-pdf',
      });
      this.metaTitle =
        'Excel to PDF Free | Convert MS Excel/XLS/XLSX to PDF Online - ThePDFLeader';
      this.metaDescription =
        'Easily convert Excel to PDF free with ThePDFLeader. Unlimited usage, no registration required. Our secure Excel to PDF online tool supports MS Excel, XLS, and XLSX spreadsheets for fast PDF export.';
      this.metaKeyword =
        'Excel to PDF, convert Excel to PDF, XLS to PDF, XLSX to PDF, online Excel to PDF converter, free Excel to PDF tool, Excel to PDF conversion';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-pdf-to-image') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-pdf-to-image',
      });
      this.metaTitle =
        'Convert PDF to JPG Free | PDF to Image Converter Online - ThePDFLeader';
      this.metaDescription =
        'Convert PDF to JPG free with ThePDFLeader. Fast, secure, and unlimited PDF to image converter online. No signup needed. Upload your file and convert PDF to JPG in seconds with full privacy.';
      this.metaKeyword =
        'PDF to image, convert PDF to JPG, convert PDF to PNG, PDF to JPG converter, PDF to PNG tool, free PDF to image, online PDF to image converter';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-image-to-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-image-to-pdf',
      });
      this.metaTitle = 'Image to PDF Converter | Convert Images to PDF Online';
      this.metaDescription =
        'Convert images (JPG, PNG, etc.) to PDF files effortlessly. Use our free online tool to combine multiple images into a single, high-quality PDF.';
      this.metaKeyword =
        'image to PDF, convert image to PDF, JPG to PDF, PNG to PDF, online image to PDF converter, free image to PDF tool, image to PDF online';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-word-to-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-word-to-pdf',
      });
      this.metaTitle =
        'Word to PDF Converter | Free Word/ Doc to PDF Online - ThePDF Leader';
      this.metaDescription =
        'Use ThePDFLeader Word to PDF converter to quickly convert Word to PDF free online. No account needed, unlimited usage, and your documents remain fully secure.';
      this.metaKeyword =
        'Word to PDF, convert Word to PDF, DOC to PDF, DOCX to PDF, online Word to PDF converter, free Word to PDF tool, convert DOCX to PDF';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-ocr-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-ocr-pdf',
      });
      this.metaTitle = 'OCR PDF Converter | Extract Text from Scanned PDFs';
      this.metaDescription =
        'Extract text from scanned PDF documents using OCR. Convert image-based PDFs to editable text with our free online OCR PDF tool.';
      this.metaKeyword =
        'OCR PDF, PDF text extraction, convert scanned PDF, OCR PDF tool, free OCR converter, extract text from PDF, editable PDF from image';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-pptx-to-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-pptx-to-pdf',
      });
      this.metaTitle = 'PPTX to PDF Converter | Convert PowerPoint to PDF';
      this.metaDescription =
        'Convert PPTX files to PDF effortlessly. Use our free online tool for quick and accurate PowerPoint to PDF conversion while preserving formatting.';
      this.metaKeyword =
        'PPTX to PDF, convert PPTX to PDF, PowerPoint to PDF, online PPTX to PDF converter, free PPTX to PDF tool, convert PowerPoint to PDF online';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'blog-compress-pdf') {
      const canonical19 = document.querySelector("link[rel='canonical']");
      if (canonical19) {
        canonical19.remove();
      }
      this.metaService.addTag({
        rel: 'canonical',
        href: 'https://www.thepdfleader.com/blog-compress-pdf',
      });
      this.metaTitle = 'Compress PDF Online | Reduce PDF File Size Easily';
      this.metaDescription =
        'Compress PDF files without losing quality. Use our free online tool to reduce PDF file size while preserving document content and clarity.';
      this.metaKeyword =
        'compress PDF, reduce PDF size, PDF compression, free PDF compressor, online PDF compressor, compress PDF online, PDF file size reduction';
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'contact-us') {
      this.titleService.setTitle('Contact Us');

      this.metaService.updateTag({
        name: 'description',
        content:
          "Get in touch with us! Visit our Contact Us page for customer support, inquiries, feedback, or assistance. We're here to help!.",
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'Contact us, Get in touch, Customer support, Assistance, Help, Inquiry, Feedback, Reach us, Support team, Message us',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/contact-us');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/contact-us');
        this.document.head.appendChild(link);
      }
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'about-us') {
      this.titleService.setTitle('About Us');

      this.metaService.updateTag({
        name: 'description',
        content:
          'Learn more about The PDF Leader, a trusted platform for PDF conversion, editing, and security. Discover our mission, values, services, and cutting-edge technology designed to make working with PDFs simple, efficient, and secure.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content:
          'PDF conversion, PDF editing, PDF security, PDF tools, PDF services, document conversion, online PDF, PDF leader, PDF solutions, PDF technology, digital document management',
      });
      let link = this.document.querySelector(
        "link[rel='canonical']",
      ) as HTMLLinkElement | null;

      if (link) {
        // ✅ Update existing
        link.setAttribute('href', 'https://www.thepdfleader.com/about-us');
      } else {
        // ✅ Create new
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.thepdfleader.com/about-us');
        this.document.head.appendChild(link);
      }
      // this.blogPage=true;
      this.isLandingDetailsPage = true;
    } else if (this.currentPath == 'login') {
      this.isLoginPage = true;
    } else if (this.currentPath == 'register') {
      this.isRegisterPage = true;
    }
  }
  ngAfterViewInit() {
    // Now it's safe to use documentUploadComponent
    // console.log('DocumentUploadComponent:', this.documentUploadComponent);
  }
  changeLoginstatus(status: any) {
    this.isLoginPage = status;
  }
  changeRegisterstatus(status: any) {
    this.isRegisterPage = status;
  }
  onMenuIconSelected(iconIdentifier: string) {
    //create header, sub header, button name as icon click
    this.isLoginPage = false;
    this.termsPage = false;
    this.isLandingPage = false;

    switch (iconIdentifier) {
      case 'htmltoimage':
        this.isWebLink = true;
        this.fileUploadService.changeHeader('HTML to Image');
        this.fileUploadService.changeSubHeader(
          'Convert a web link to an image for free',
        );
        this.fileUploadService.changeButtonName('Choose HTML Link');
        this.fileUploadService.cchangeButtonName('Convert to Image');
        this.fileUploadService.cchangeHeader('Convert HTML File to Image');
        this.fileUploadService.changeHtmltoImageRequest('htmltoimage');
        this.fileUploadService.changeDownloadheaderRequest(
          'The HTML has been converted into an image!',
        );
        this.fileUploadService.changeDownloadButtonRequest(
          'Download Image File',
        );
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('png');
        this.fileUploadService.changeSubSubHeader('Website url');

        break;
      case 'wordtopng':
        this.fileUploadService.changeFileType('word');
        this.fileUploadService.changeHeader(
          'Word to PNG Converter – Fast & Free',
        );
        this.fileUploadService.changeSubHeader(
          'Convert Word (DOC, DOCX) to PNG Images Instantly – No Signup Needed',
        );
        this.fileUploadService.changeButtonName('Choose Word file');
        this.fileUploadService.cchangeButtonName('Convert to PNG');
        this.fileUploadService.cchangeHeader(
          'Convert Word to PNG – Fast & Free',
        );
        this.fileUploadService.changeDownloadheaderRequest(
          'The Word document has been converted into an image!',
        );
        this.fileUploadService.changeDownloadButtonRequest(
          'Download PNG Image',
        );
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('zip');
        break;
      case 'watermark':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('Add a watermark to a PDF file');
        this.fileUploadService.changeSubHeader(
          'Add a text or image watermark to your PDF file in seconds',
        );
        this.fileUploadService.changeButtonName('Choose Pdf File');
        this.fileUploadService.cchangeButtonName('Add Watermark');
        this.fileUploadService.cchangeHeader('Watermark options');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been watermarked!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        break;
      //*************************************** */

      case 'unlock':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('Unlock PDF');
        this.fileUploadService.changeSubHeader(
          'Remove the PDF password security, allowing you to open the PDF without a password',
        );
        this.fileUploadService.changeButtonName('Choose Pdf File');
        this.fileUploadService.cchangeButtonName('Unlock PDF');
        this.fileUploadService.cchangeHeader('Unlock PDF Document');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been unlocked!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        this.fileUploadService.changeSubSubHeader('Password');
        break;
      case 'protect':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('Protect PDF');
        this.fileUploadService.changeSubHeader(
          'Protect your PDF file so that no one can open it without a password',
        );
        this.fileUploadService.changeButtonName('Choose Pdf File');
        this.fileUploadService.cchangeButtonName('Protect PDF');
        this.fileUploadService.cchangeHeader('Add Password to PDF');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been protected with a password!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        this.fileUploadService.changeSubSubHeader('Password');
        break;
      case 'merge':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('Merge PDF');
        this.fileUploadService.changeSubHeader(
          'Combine multiple PDF files into one file',
        );
        this.fileUploadService.changeButtonName('Choose Pdf Files');
        this.fileUploadService.cchangeButtonName('Merge PDF');
        this.fileUploadService.cchangeHeader('Merge PDF Documents');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been merged!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        break;
      case 'split':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('Split PDF');
        this.fileUploadService.changeSubHeader(
          'Separate each page of the PDF from a multi-page PDF file',
        );
        this.fileUploadService.changeButtonName('Choose Pdf File');
        this.fileUploadService.cchangeButtonName('Split PDF');
        this.fileUploadService.cchangeHeader('Split PDF Files');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been split!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('zip');
        break;
      case 'pdftoword':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('PDF to Word');
        this.fileUploadService.changeSubHeader(
          'Convert your PDF file to a Word file for free',
        );
        this.fileUploadService.changeButtonName('Choose Pdf File');
        this.fileUploadService.cchangeButtonName('Convert to Word');
        this.fileUploadService.cchangeHeader('PDF to Word Document');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been converted into a Word document!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download WORD');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('word');
        break;
      case 'htmltopdf':
        this.isWebLink = true;
        this.fileUploadService.changeHeader('HTML to PDF');
        this.fileUploadService.changeSubHeader(
          'Convert a web page to a PDF file for free',
        );
        this.fileUploadService.changeButtonName('Choose HTML Link');
        this.fileUploadService.cchangeButtonName('Convert to PDF');
        this.fileUploadService.cchangeHeader('Generate PDF from HTML');
        this.fileUploadService.changeHtmltoPdfRequest('htmltopdf');
        this.fileUploadService.changeDownloadheaderRequest(
          'The HTML has been converted into a PDF.!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        this.fileUploadService.changeSubSubHeader('Website Url');
        break;

      case 'pdftoimage':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('PDF to Image');
        this.fileUploadService.changeSubHeader(
          'Convert a PDF file to an image file for free',
        );
        this.fileUploadService.changeButtonName('Choose Pdf file');
        this.fileUploadService.cchangeButtonName('PDF to Image');
        this.fileUploadService.cchangeHeader('PDF to Image');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been converted into an image!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download Image');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('zip');
        break;
      case 'imagetopdf':
        this.fileUploadService.changeFileType('image');
        this.fileUploadService.changeHeader('Image to PDF');
        this.fileUploadService.changeSubHeader(
          'Convert image files (JPG, PNG, WEBP, SVG) to PDF for free',
        );
        this.fileUploadService.changeButtonName('Choose Image File');
        this.fileUploadService.cchangeButtonName('Convert to PDF');
        this.fileUploadService.cchangeHeader('Image to PDF');
        this.fileUploadService.changeDownloadheaderRequest(
          'The image has been converted into a PDF!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        break;
      case 'wordtopdf':
        this.fileUploadService.changeFileType('word');
        this.fileUploadService.changeHeader('Word to PDF');
        this.fileUploadService.changeSubHeader(
          'Convert a Word file to a PDF file for free ',
        );
        this.fileUploadService.changeButtonName('Choose Word File');
        this.fileUploadService.cchangeButtonName('Convert to PDF');
        this.fileUploadService.cchangeHeader('Word to PDF');
        this.fileUploadService.changeDownloadheaderRequest(
          'The Word document has been converted into a PDF!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        break;
      case 'pdftoexcel':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('PDF to Excel');
        this.fileUploadService.changeSubHeader(
          'Convert a PDF file to an Excel file',
        );
        this.fileUploadService.changeButtonName('Choose Pdf File');
        this.fileUploadService.cchangeButtonName('Convert to EXCEL');
        this.fileUploadService.cchangeHeader('PDF to ExcelL');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been converted into an Excel file!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download Excel');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('excel');
        break;
      case 'exceltopdf':
        this.fileUploadService.changeFileType('excel');
        this.fileUploadService.changeHeader('Excel to PDF');
        this.fileUploadService.changeSubHeader(
          'Convert an Excel file to a PDF file',
        );
        this.fileUploadService.changeButtonName('Choose Excel File');
        this.fileUploadService.cchangeButtonName('Convert to PDF');
        this.fileUploadService.cchangeHeader('Excel to PDF');
        this.fileUploadService.changeDownloadheaderRequest(
          'The Excel file has been converted into a PDF!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        break;
      case 'ocr':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('OCR PDF');
        this.fileUploadService.changeSubHeader(
          'Convert image-based PDFs into searchable and selectable PDFs using OCR',
        );
        this.fileUploadService.changeButtonName('Choose PDF File');
        this.fileUploadService.cchangeButtonName('Perform OCR');
        this.fileUploadService.cchangeHeader('OCR PDF');
        this.fileUploadService.changeDownloadheaderRequest(
          'The searchable and selectable PDFs have been created!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        break;
      case 'compress':
        this.fileUploadService.changeFileType('pdf');
        this.fileUploadService.changeHeader('Compress PDF');
        this.fileUploadService.changeSubHeader(
          'Compress PDF files to reduce their size while maintaining quality and content integrity',
        );
        this.fileUploadService.changeButtonName('Choose PDF File');
        this.fileUploadService.cchangeButtonName('Compress PDF');
        this.fileUploadService.cchangeHeader('Compress PDF');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PDF has been successfully compressed!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        break;
      case 'pptxtopdf':
        this.fileUploadService.changeFileType('pptx');
        this.fileUploadService.changeHeader('Convert PowerPoint to PDF');
        this.fileUploadService.changeSubHeader(
          'Convert PowerPoint presentations (PPTX) to high-quality PDF files while preserving their layout and formatting',
        );
        this.fileUploadService.changeButtonName('Choose PDF File');
        this.fileUploadService.cchangeButtonName('Convert to PDF');
        this.fileUploadService.cchangeHeader('PowerPoint Presentation to PDF');
        this.fileUploadService.changeDownloadheaderRequest(
          'The PowerPoint presentation has been successfully converted to PDF!',
        );
        this.fileUploadService.changeDownloadButtonRequest('Download PDF');
        this.fileUploadService.changeiconIdentifierRequest(iconIdentifier);
        this.fileUploadService.changeDownloadFileType('pdf');
        break;
      // Add more cases as needed
      default:
        this.fileUploadService.changeHeader('Default Header');
        this.fileUploadService.changeSubHeader('Default Sub Header');
        this.fileUploadService.changeButtonName('Default Button');
    }
    this.showComponents = false;
    const endpointUrl = `${this.BASE_URL}/${this.endpointsUrl[iconIdentifier]}`;
    if (endpointUrl) {
      if (this.documentUploadComponent) {
        this.documentUploadComponent.onIconSelected(endpointUrl);
      } else {
        console.error('DocumentUploadComponent is not initialized yet.');
      }
    } else {
      console.error(`No endpoint found for icon: ${iconIdentifier}`);
    }
  }

  // updateSchema(currentUrl: string) {
  //   // Define dynamic schema based on current URL
  //   // const schemaData = this.getSchemaForPage(currentUrl);
  //     this.updateSchemaStruct(currentUrl);
  //   // Remove old schema tags
  //   const existingScript = document.querySelector(
  //     'script[type="application/ld+json"]',
  //   );
  //   if (existingScript) {
  //     existingScript.remove();
  //   }

  //   // Create a new script element for JSON-LD
  //   const script = document.createElement('script');
  //   script.type = 'application/ld+json';
  //   // script.text = JSON.stringify(schemaData);
  //   script.textContent = this.schemaJson;
  //   // Append it to the document head
  //   document.head.appendChild(script);
  // }

  updateSchema(currentUrl: string) {

  // Always build schema JSON (safe for SSR)
  this.updateSchemaStruct(currentUrl);

  // Run DOM manipulation only in browser
  if (isPlatformBrowser(this.platformId)) {

    try {

      // Remove old schema if exists
      const existingScript = document.head.querySelector(
        'script[type="application/ld+json"]'
      );

      if (existingScript) {
        existingScript.remove();
      }

      // Create new JSON-LD script
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = this.schemaJson;

      // Append to head
      document.head.appendChild(script);

    } catch (err) {
      console.error('Schema injection error:', err);
    }
  }
}
updateSchemaStruct(url:string)
{
  // Example for homepage
    if (url === '') {
      const schema = [
        this.schemaService.getOrganizationSchema(),
        this.schemaService.getWebsiteSchema(),
        this.schemaService.getBreadcrumbSchema(url),
      ];
      this.schemaJson = JSON.stringify({ "@context": "https://schema.org", "@graph": schema });
    }

    // Example for /pdf-merge
     else if (url.includes('pdf-merge')) {
      const schema = [
        this.schemaService.getSoftwareApplicationSchema(
          "Merge PDF",
          url,
          "Easily merge multiple PDF files into one document online. Free, secure, and fast with no installation required."
        ),
        this.schemaService.getBreadcrumbSchema(url),
        this.schemaService.getHowToSchema("How to Merge/Combine Multiple PDFs in One PDF File?", "Follow these 3 easy steps to combine PDF files for free with ThePDFLeader – no signup or software needed.", [
          { title: "Step 1: Click on \"Click or drag file to upload\"", text: "Select at least two PDF documents from your computer or mobile. You can upload multiple files at once. There's no limit on file size or number. Just drag and drop to get started." },
          { title: "Step 2: Preview & Merge PDF", text: "Your selected files will load in the tool. You can rearrange, preview, add more, or delete any before combining. Once ready, just click \"Merge PDF\" and your files will integrate into one single document within seconds." },
          { title: "Step 3: Download Your PDF File", text: "That's it! Your PDF files are now grouped into one. Just hit the Download button to save the merged file to your system." },
        ]),
        this.schemaService.getFAQSchema([
          { q: "Is ThePDFLeader PDF merger tool free?", a: "Yes, it’s 100% free to merge PDF files online – no cost, no signup." },
          { q: "How many files can I combine at once?", a: "You can upload and group multiple files – there’s no limit on quantity or file size." },
          { q: "Do I need to install software?", a: "No. The tool works in any web browser – no installation required." },
          { q: "Can I use it on my phone?", a: "Yes! You can upload files from your mobile and merge them easily." },
           { q: "Are my PDFs safe?", a: "Absolutely. Your PDF documents are auto-deleted from our servers after you download the merged file." },
          { q: "What file types are supported?", a: "The PDF merger tool supports PDF only. Simply upload your PDF files and start combining." },
          { q: "Can I rearrange files before merging?", a: "Yes. You can drag and drop to reorder files before hitting the click merge button." },
          { q: "Will the tool work on Windows or Linux?", a: "Yes, our PDF merger works smoothly in any browser on Windows, Linux, macOS, and all devices." },
          { q: "Can I preview the file before merging?", a: "Yes. You can preview, remove, or add files before finalizing your single document." },
           { q: "Is there a file storage limit?", a: "No limit! Just drop the files and combine them — simple and seamless." },

        ]),
      ];
      this.schemaJson = JSON.stringify({ "@context": "https://schema.org", "@graph": schema });
    }
else if (url.includes('pdf-split')) {
      const schema = [
        this.schemaService.getSoftwareApplicationSchema(
          "Split PDF",
          url,
          "Split PDF files into separate documents with precision and ease. Select specific pages or define custom ranges to organize your content efficiently. Secure, reliable, and accessible online without any software installation"
        ),
        this.schemaService.getBreadcrumbSchema(url),
        this.schemaService.getHowToSchema("How to Extract/Split PDF File?", "Follow these 3 easy steps to split PDF files or extract file online using ThePDFLeader. No sign-up, no fuss – just a fast and reliable experience.", [
          { title: "Step 1: Click on \"Click or drag file to upload\"", text: "Upload the PDF file you want to split or extract specific pages from. Your PDF document should have at least 2 pages to be separated. You can also extract file online directly from your PC, mobile, or  web browser." },
          { title: "Step 2: Preview & Split PDF", text: "i. Default This will split PDF into individual files, where each page becomes a separate PDF file. Software Utilitiesii. Extract– Choose a page range like 5–10 or 15–25. Only those PDF pages from that range will be saved as a new file.iii. Interval – Select the number after which you want to divide the file, e.g., split after 10th page or 20th page onwards.Choose the method that fits your needs. Then, click \"Split PDF\"." },
          { title: "Step 3: Download Your PDF File", text: "Done! Your file is now split or extracted as requested. Click the download button to save the new PDF on your device. It’s fast, safe, and works in any browser." },
        ]),
        this.schemaService.getFAQSchema([
          { q: "Is ThePDFLeader a free PDF split tool?", a: "Yes, you can split PDF online free without limits using our secure and easy platform." },
          { q: "Can I extract PDF pages instead of splitting everything?", a: "Absolutely. Just use the extract PDF option to select the pages you need." },
          { q: "How do I extract file online from a PDF?", a: "Upload your file, pick the page range, and download. It's that simple to extract file online with ThePDFLeader." },
          { q: "Can I split PDF free without creating an account?", a: "Yes! Our tool is 100% free and requires no login to split PDF files." },
           { q: "Is there any page or file size limit?", a: "No limits at all. Upload any size PDF file and split it freely." },
          { q: "Will it work on both Windows and Mac?", a: "Yes. Our online tools work on all  operating systems including Windows, Mac, and mobile devices." },
          { q: "Can I split PDF into multiple files by page range?", a: "Yes, just enter the range and we’ll extract PDF pages into new files." },
          { q: "Is this tool secure? Are my files saved?", a: "No, your files are automatically deleted from our servers after processing for your full privacy." },
          { q: "Can I use drag and drop to upload files?", a: "Yes! You can drag and drop the file and click to start processing immediately." },
           { q: "What makes ThePDFLeader better than others?", a: "We offer split PDF online free, fast, and secure with no signup, ads, or limits." },

        ]),
      ];
      this.schemaJson = JSON.stringify({ "@context": "https://schema.org", "@graph": schema });
    }
else if (url.includes('html-to-image')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "HTML to Image",
      url,
      "Convert any web page or HTML link into a high-quality PNG image online for free. Fast, secure, and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert HTML to Image?",
      "Follow these 3 simple steps to turn any web page into an image using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Choose HTML Link\" Button",
          text: "Paste the website link you want to convert into an image. Enter the full URL in the input box and click the Add button. Example: https://www.google.com/"
        },
        {
          title: "Step 2: Preview & Convert to Image",
          text: "Once your link is added, preview the page and click on the \"Convert to Image\" button. The tool will process your HTML and generate an image instantly."
        },
        {
          title: "Step 3: Download Your Image",
          text: "Within seconds, your web page will be converted into a PNG image. Click the Download button to save it to your device."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How do I convert HTML to PNG using ThePDFLeader?",
        a: "Paste your HTML link, click convert, and download the PNG file instantly."
      },
      {
        q: "Can I convert a link to image format?",
        a: "Yes, simply paste the web link and our tool will generate a downloadable image."
      },
      {
        q: "Does this tool support HTML to PNG conversion?",
        a: "Yes, you can easily convert any HTML page or web link into PNG format."
      },
      {
        q: "Is it safe to use this tool?",
        a: "Yes, your data is secure. We do not store your links or generated images."
      },
      {
        q: "Do I need to install any software?",
        a: "No, this is a fully online tool and works directly in your browser."
      },
      {
        q: "Can I use it on mobile devices?",
        a: "Yes, the tool works perfectly on mobile, tablet, and desktop devices."
      },
      {
        q: "How long does the conversion take?",
        a: "It usually takes just a few seconds to convert a web page into an image."
      },
      {
        q: "Can I convert large HTML pages?",
        a: "Yes, but this tool is best suited for single-page capture."
      },
      {
        q: "What image format will I get?",
        a: "You will receive a high-quality PNG image after conversion."
      },
      {
        q: "Do you store my links or files?",
        a: "No, we respect your privacy and do not store any data."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('pdf-to-word')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "PDF to Word",
      url,
      "Convert PDF files to editable Word documents online for free. Fast, secure, and no signup required with high-quality output."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert PDF to Word File?",
      "Follow these 3 simple steps to convert your PDF file into an editable Word document using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload the PDF file you want to convert. You can select or drag and drop your file into the upload area."
        },
        {
          title: "Step 2: Preview & Convert to Word",
          text: "After uploading, preview your document pages. Then click on the \"Convert to Word\" button to start the conversion process."
        },
        {
          title: "Step 3: Download Your Word File",
          text: "Your PDF will be converted into an editable Word document. Click the Download button to save it to your device."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "What is ThePDFLeader?",
        a: "ThePDFLeader is an online tool that allows you to convert PDF files to Word documents quickly and securely without signup."
      },
      {
        q: "Is it really free to convert PDFs?",
        a: "Yes, you can convert PDF to Word completely free with no hidden charges."
      },
      {
        q: "Can I convert a scanned PDF?",
        a: "Yes, scanned PDFs can also be converted using OCR (Optical Character Recognition) technology."
      },
      {
        q: "Will the formatting remain the same?",
        a: "Yes, the tool preserves layout, fonts, and images as much as possible in the converted Word file."
      },
      {
        q: "Do I need to install any software?",
        a: "No, the tool works entirely online in your browser."
      },
      {
        q: "What file formats are supported?",
        a: "You can convert PDF files into editable Word formats like DOCX or text documents."
      },
      {
        q: "Is it safe to use?",
        a: "Yes, your files are secure and automatically deleted after download."
      },
      {
        q: "Can I use it on mobile devices?",
        a: "Yes, the PDF to Word converter works on mobile, tablet, and desktop devices."
      },
      {
        q: "Does it support large files?",
        a: "Yes, the tool can handle large PDF files efficiently."
      },
      {
        q: "How many times can I use it?",
        a: "You can use the tool unlimited times without any restrictions."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('html-to-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "HTML to PDF",
      url,
      "Convert any web page or HTML link into a high-quality PDF file online for free. Fast, secure, and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert HTML to PDF?",
      "Follow these 3 simple steps to save your web pages as PDF files using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Choose HTML Link\" Button",
          text: "Paste the website link you want to convert into a PDF. Enter the full URL and click the Add button. Example: https://www.google.com/"
        },
        {
          title: "Step 2: Preview & Convert to PDF",
          text: "Once your link is added, preview the page and click on the \"Convert to PDF\" button to start the conversion."
        },
        {
          title: "Step 3: Download Your PDF File",
          text: "Within seconds, your web page will be converted into a PDF file. Click the Download button to save it to your device."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How can I convert HTML to PDF with ThePDFLeader?",
        a: "Paste your link, click convert, and download your PDF file instantly."
      },
      {
        q: "Is this tool free to use?",
        a: "Yes, you can convert HTML to PDF for free with no signup required."
      },
      {
        q: "Can I upload an HTML file from my computer?",
        a: "Yes, you can upload HTML files directly from your device for conversion."
      },
      {
        q: "Does it work on all browsers?",
        a: "Yes, the tool works smoothly on Chrome, Firefox, Safari, and other modern browsers."
      },
      {
        q: "Will formatting be preserved?",
        a: "Yes, the tool maintains layout, fonts, and images as per the original webpage."
      },
      {
        q: "Can it handle long web pages?",
        a: "Yes, long pages are supported without breaking the layout."
      },
      {
        q: "Is my data सुरक्षित?",
        a: "Yes, we do not store your files. All conversions are secure and private."
      },
      {
        q: "Can I select page size?",
        a: "Yes, you can choose your preferred page size before conversion."
      },
      {
        q: "What output format will I get?",
        a: "You will receive a PDF file compatible with all devices."
      },
      {
        q: "Can I use it on mobile devices?",
        a: "Yes, the tool works on smartphones, tablets, and desktops."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('unlock-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "Unlock PDF",
      url,
      "Remove password protection from PDF files online for free. Unlock secured PDFs quickly, safely, and without signup."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Unlock PDF?",
      "Follow these 3 simple steps to remove password protection from your PDF file using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload the locked or password-protected PDF file you want to unlock from your device."
        },
        {
          title: "Step 2: Enter Password",
          text: "Enter the correct password of the PDF file to remove its security restrictions."
        },
        {
          title: "Step 3: Download Unlocked PDF",
          text: "Once processed, download your unlocked PDF file and access it without any password restrictions."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How can I unlock PDF online for free?",
        a: "Upload your PDF, enter the correct password, and download the unlocked file instantly."
      },
      {
        q: "Can I remove password from PDF without original password?",
        a: "No, you must provide the correct password to unlock a secured PDF file."
      },
      {
        q: "Does ThePDFLeader store my files?",
        a: "No, all uploaded files are automatically deleted after processing."
      },
      {
        q: "Do I need to install any software?",
        a: "No, the tool works directly in your browser without installation."
      },
      {
        q: "Is it safe to unlock sensitive PDFs?",
        a: "Yes, your files are processed securely and are not stored or shared."
      },
      {
        q: "Does it work on all devices?",
        a: "Yes, it works on Windows, macOS, Linux, Android, and iOS devices."
      },
      {
        q: "What is a permissions password?",
        a: "It is a password that restricts editing, printing, or copying content in a PDF file."
      },
      {
        q: "Can I open the PDF without password after unlocking?",
        a: "Yes, once unlocked, the PDF can be opened without entering a password."
      },
      {
        q: "Do I need Adobe Acrobat to unlock PDF?",
        a: "No, you can unlock PDFs directly online without Adobe Acrobat."
      },
      {
        q: "How long does the unlocking process take?",
        a: "Most PDF files are unlocked within a few seconds."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('protect-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "Protect PDF",
      url,
      "Add password protection to PDF files online for free. Secure your documents with strong encryption, fast processing, and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Protect PDF / Set Password?",
      "Follow these 3 simple steps to add password protection to your PDF file using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload the PDF file you want to protect from your device by selecting or dragging it into the upload area."
        },
        {
          title: "Step 2: Set Password",
          text: "Enter a strong password using a mix of letters, numbers, and symbols. Then click \"Protect PDF\" to secure your document."
        },
        {
          title: "Step 3: Download Protected PDF",
          text: "Within seconds, your PDF will be protected. Click the Download button to save your secured file."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How can I protect my PDF file with a password?",
        a: "Upload your PDF, set a password, click protect, and download the secured file."
      },
      {
        q: "Is it safe to protect PDF online?",
        a: "Yes, your files are processed securely and not stored on our servers."
      },
      {
        q: "Do I need to install any software?",
        a: "No, the tool works directly in your browser without installation."
      },
      {
        q: "What is the best password for securing a PDF?",
        a: "Use a combination of uppercase, lowercase letters, numbers, and special characters for strong security."
      },
      {
        q: "Can I remove the password later?",
        a: "Yes, you can remove the password using a PDF unlock tool anytime."
      },
      {
        q: "Does password protection restrict editing?",
        a: "Yes, adding a password can restrict editing, copying, and printing of the document."
      },
      {
        q: "How long does it take to protect a PDF?",
        a: "It usually takes only a few seconds depending on file size."
      },
      {
        q: "Can I protect multiple PDFs at once?",
        a: "Currently, you can protect one PDF at a time for better security."
      },
      {
        q: "What if I forget the password?",
        a: "You will need the correct password to open the PDF, so keep it सुरक्षित."
      },
      {
        q: "Is this feature free to use?",
        a: "Yes, you can password protect PDF files online for free."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('watermark-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "Add Watermark to PDF",
      url,
      "Add text or image watermark to PDF files online for free. Protect and brand your documents instantly with fast, secure processing and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Add Watermark to PDF?",
      "Follow these 3 simple steps to add watermark to your PDF file using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload the PDF file you want to add a watermark to from your device."
        },
        {
          title: "Step 2: Add Text or Image Watermark",
          text: "Enter your watermark text or upload an image/logo. Choose the position where you want the watermark to appear on the PDF."
        },
        {
          title: "Step 3: Download Watermarked PDF",
          text: "Once processed, download your PDF file with the applied watermark."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How can I add watermark to PDF using ThePDFLeader?",
        a: "Upload your PDF, add text or image watermark, and download the updated file."
      },
      {
        q: "Can I add watermark without installing software?",
        a: "Yes, the tool works completely online in your browser."
      },
      {
        q: "Does it support both text and image watermarks?",
        a: "Yes, you can add text, logo, or image as a watermark."
      },
      {
        q: "Will my files be stored?",
        a: "No, your files are not stored and are processed securely."
      },
      {
        q: "Can I choose watermark position?",
        a: "Yes, you can place the watermark in different positions like center, corners, or across the page."
      },
      {
        q: "Is it suitable for official documents?",
        a: "Yes, it is commonly used for contracts, reports, and presentations."
      },
      {
        q: "Can I apply watermark to all pages?",
        a: "Yes, the watermark can be applied across all pages of your PDF."
      },
      {
        q: "Can I add a logo as watermark?",
        a: "Yes, you can upload and use your logo as a watermark."
      },
      {
        q: "Do I need to sign up?",
        a: "No, no registration is required to use this tool."
      },
      {
        q: "How long does the process take?",
        a: "It usually takes just a few seconds to apply watermark and download the file."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('pdf-to-excel')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "PDF to Excel",
      url,
      "Convert PDF files to Excel spreadsheets online for free. Fast, accurate, and secure PDF to XLSX conversion with no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert PDF to Excel?",
      "Follow these 3 simple steps to convert your PDF file into an Excel spreadsheet using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload the PDF file you want to convert into Excel format. You can select or drag and drop your file easily."
        },
        {
          title: "Step 2: Preview & Convert to Excel",
          text: "Preview your uploaded PDF pages and click on the \"Convert to Excel\" button to start the conversion process."
        },
        {
          title: "Step 3: Download Excel File",
          text: "Within seconds, your PDF will be converted into an Excel (.xlsx) file. Click Download to save it."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How do I convert PDF to Excel using ThePDFLeader?",
        a: "Upload your PDF, preview it, click convert, and download the Excel file."
      },
      {
        q: "Is the PDF to Excel converter free?",
        a: "Yes, you can convert PDF to Excel for free with no hidden charges."
      },
      {
        q: "Can I convert large PDF files?",
        a: "Yes, the tool supports both small and large PDF files efficiently."
      },
      {
        q: "Will formatting be preserved?",
        a: "Yes, tables, rows, and columns are maintained as in the original PDF."
      },
      {
        q: "Do I need to install any software?",
        a: "No, the tool works completely online in your browser."
      },
      {
        q: "Is my data safe?",
        a: "Yes, your files are processed securely and automatically deleted after conversion."
      },
      {
        q: "What formats are supported?",
        a: "The tool converts PDF into Excel formats like XLSX and XLS."
      },
      {
        q: "Can I use this tool on mobile?",
        a: "Yes, it works on smartphones, tablets, and desktops."
      },
      {
        q: "What is the difference between XLS and XLSX?",
        a: "XLS is an older Excel format, while XLSX is the modern and widely used format."
      },
      {
        q: "Why use ThePDFLeader PDF to Excel tool?",
        a: "It is fast, free, secure, and requires no signup, making conversion easy."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('word-to-png')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "Word to PNG Converter",
      url,
      "Convert Word (DOC, DOCX) files to high-quality PNG images online for free. Fast, secure, and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert Word to PNG?",
      "Follow these 3 simple steps to convert your Word document into PNG images using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload your Word file (DOC or DOCX). You can select or drag and drop your document into the upload area."
        },
        {
          title: "Step 2: Convert Word to PNG",
          text: "After uploading, click on the \"Convert to PNG\" button. The tool will process your document and generate PNG images."
        },
        {
          title: "Step 3: Download PNG Images",
          text: "Once conversion is complete, download the ZIP file containing all PNG images and extract them to use."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How do I convert Word to PNG using ThePDFLeader?",
        a: "Upload your Word file, click convert, and download the PNG images instantly."
      },
      {
        q: "Does it support DOC and DOCX files?",
        a: "Yes, both DOC and DOCX formats are supported."
      },
      {
        q: "Will the image quality be good?",
        a: "Yes, the tool generates high-quality PNG images with clear text and layout."
      },
      {
        q: "Is my document safe?",
        a: "Yes, files are processed securely and automatically deleted after conversion."
      },
      {
        q: "Can I convert multi-page Word documents?",
        a: "Yes, each page will be converted into a separate PNG image inside a ZIP file."
      },
      {
        q: "Do I need to install any software?",
        a: "No, the tool works completely online in your browser."
      },
      {
        q: "What format will I receive?",
        a: "You will receive PNG images packed in a ZIP file."
      },
      {
        q: "Can I add watermark during conversion?",
        a: "No, this tool is focused on conversion. You can use the watermark tool separately."
      },
      {
        q: "Why choose PNG over JPEG?",
        a: "PNG uses lossless compression, ensuring better quality especially for text documents."
      },
      {
        q: "Do I need to sign up?",
        a: "No, no registration is required to use this tool."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('excel-to-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "Excel to PDF",
      url,
      "Convert Excel (XLS, XLSX) files to PDF online for free. Fast, secure, and accurate spreadsheet to PDF conversion with no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert Excel to PDF?",
      "Follow these 3 simple steps to convert your Excel file into a PDF using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload your Excel file (XLS or XLSX) by selecting or dragging it into the upload area."
        },
        {
          title: "Step 2: Convert Excel to PDF",
          text: "After uploading, click on the \"Excel to PDF\" button to start the conversion process."
        },
        {
          title: "Step 3: Download PDF File",
          text: "Within seconds, your Excel file will be converted into a PDF. Click Download to save it."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How do I convert Excel to PDF using ThePDFLeader?",
        a: "Upload your Excel file, click convert, and download the PDF instantly."
      },
      {
        q: "Does it support XLS and XLSX formats?",
        a: "Yes, both XLS and XLSX formats are supported."
      },
      {
        q: "Do I need to install any software?",
        a: "No, the tool works completely online in your browser."
      },
      {
        q: "Is my data safe?",
        a: "Yes, your files are processed securely and not stored after conversion."
      },
      {
        q: "Can I use this tool without signup?",
        a: "Yes, no registration is required to use this tool."
      },
      {
        q: "How fast is the conversion?",
        a: "It usually takes only a few seconds depending on file size."
      },
      {
        q: "Is there any limit on conversions?",
        a: "No, you can convert unlimited files for free."
      },
      {
        q: "Can I convert large Excel files?",
        a: "Yes, large spreadsheets are supported and processed efficiently."
      },
      {
        q: "Will formatting be preserved?",
        a: "Yes, tables, charts, and layout remain intact after conversion."
      },
      {
        q: "Why use ThePDFLeader Excel to PDF tool?",
        a: "It is fast, free, secure, and easy to use without signup."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('pdf-to-image')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "PDF to Image",
      url,
      "Convert PDF files to high-quality JPG or PNG images online for free. Fast, secure, and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert PDF to Image?",
      "Follow these 3 simple steps to convert your PDF file into images using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload your PDF file by selecting or dragging it into the upload area. You can upload single or multi-page documents."
        },
        {
          title: "Step 2: Convert PDF to Image",
          text: "After uploading, click on the \"PDF to Image\" button. The tool will process your file and generate JPG or PNG images."
        },
        {
          title: "Step 3: Download Images",
          text: "Within seconds, download a ZIP file containing all pages as separate images."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How do I convert PDF to image using ThePDFLeader?",
        a: "Upload your PDF, click convert, and download the images instantly."
      },
      {
        q: "Can I convert PDF to JPG for free?",
        a: "Yes, the tool allows free PDF to JPG conversion with no limits."
      },
      {
        q: "Does it support multi-page PDFs?",
        a: "Yes, each page is converted into a separate image."
      },
      {
        q: "Is my data safe?",
        a: "Yes, files are processed securely and not stored after conversion."
      },
      {
        q: "Do I need to sign up?",
        a: "No, the tool works without registration."
      },
      {
        q: "What formats are supported?",
        a: "You can convert PDF to JPG or PNG formats."
      },
      {
        q: "How fast is the conversion?",
        a: "It usually takes just a few seconds depending on file size."
      },
      {
        q: "Is there any file size limit?",
        a: "No, both small and large files are supported."
      },
      {
        q: "Can I convert scanned PDFs?",
        a: "Yes, scanned documents can also be converted into images."
      },
      {
        q: "Why use ThePDFLeader PDF to Image tool?",
        a: "It is fast, free, secure, and easy to use without signup."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('image-to-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "Image to PDF",
      url,
      "Convert images (JPG, PNG, WEBP, SVG) to PDF online for free. Fast, secure, and high-quality image to PDF conversion with no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert Image to PDF?",
      "Follow these 3 simple steps to convert your images into a single PDF using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload your image files (JPG, PNG, WEBP, SVG) by selecting or dragging them into the upload area."
        },
        {
          title: "Step 2: Convert Image to PDF",
          text: "After uploading, click on the \"Convert to PDF\" button. The tool will process your images and combine them into a PDF."
        },
        {
          title: "Step 3: Download PDF File",
          text: "Within seconds, your PDF will be ready. Click Download to save your file."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How do I convert JPG to PDF using ThePDFLeader?",
        a: "Upload your images, click convert, and download your PDF instantly."
      },
      {
        q: "Can I combine multiple images into one PDF?",
        a: "Yes, you can merge multiple images into a single PDF file."
      },
      {
        q: "Do I need to install any software?",
        a: "No, the tool works completely online in your browser."
      },
      {
        q: "Is the tool free to use?",
        a: "Yes, you can convert images to PDF for free with no limits."
      },
      {
        q: "Will image quality be preserved?",
        a: "Yes, the original image quality is maintained in the PDF."
      },
      {
        q: "What formats are supported?",
        a: "The tool supports JPG, PNG, WEBP, SVG, and other image formats."
      },
      {
        q: "Is there any file size limit?",
        a: "No, both small and large files are supported."
      },
      {
        q: "Are my files सुरक्षित?",
        a: "Yes, your files are processed securely and deleted after conversion."
      },
      {
        q: "Can I use it on mobile devices?",
        a: "Yes, the tool works on smartphones, tablets, and desktops."
      },
      {
        q: "Why use ThePDFLeader Image to PDF tool?",
        a: "It is fast, free, secure, and easy to use without signup."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('word-to-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "Word to PDF",
      url,
      "Convert Word (DOC, DOCX) files to PDF online for free. Fast, secure, and accurate conversion with no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert Word to PDF?",
      "Follow these 3 simple steps to convert your Word document into a PDF using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload your Word document (DOC or DOCX) by selecting or dragging it into the upload area."
        },
        {
          title: "Step 2: Convert Word to PDF",
          text: "Preview your document and click on the \"Convert to PDF\" button to start the conversion."
        },
        {
          title: "Step 3: Download PDF File",
          text: "Within seconds, your Word file will be converted into a PDF. Click Download to save it."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "Can I convert multiple Word files to PDF at once?",
        a: "Yes, you can upload multiple DOC or DOCX files and convert them together."
      },
      {
        q: "Do I need to install any software?",
        a: "No, the tool works completely online in your browser."
      },
      {
        q: "Are my files safe?",
        a: "Yes, all files are processed securely and deleted after conversion."
      },
      {
        q: "Is it free to use?",
        a: "Yes, you can convert Word to PDF for free with unlimited usage."
      },
      {
        q: "Will formatting be preserved?",
        a: "Yes, fonts, images, tables, and layout remain intact."
      },
      {
        q: "What file formats are supported?",
        a: "DOC and DOCX formats are fully supported."
      },
      {
        q: "Can I use this on mobile?",
        a: "Yes, the tool works on smartphones, tablets, and desktops."
      },
      {
        q: "How fast is the conversion?",
        a: "Most files are converted within a few seconds."
      },
      {
        q: "Can I merge PDFs after conversion?",
        a: "Yes, you can use a PDF merger tool after converting."
      },
      {
        q: "Do I need to sign up?",
        a: "No, no registration is required to use this tool."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('ocr-pdf-image')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "OCR PDF",
      url,
      "Convert scanned or image-based PDFs into searchable and selectable PDFs using OCR online for free. Fast, secure, and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert Image-Based PDF to Searchable PDF Using OCR?",
      "Follow these 3 simple steps to convert scanned PDFs into searchable documents using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload your scanned or image-based PDF file by selecting or dragging it into the upload area."
        },
        {
          title: "Step 2: Perform OCR",
          text: "Click on the \"Perform OCR\" button. The tool will recognize text using OCR technology and convert it into selectable and searchable content."
        },
        {
          title: "Step 3: Download Searchable PDF",
          text: "Once processing is complete, download your searchable PDF file and easily copy or extract text."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "What is PDF OCR?",
        a: "PDF OCR (Optical Character Recognition) converts scanned PDFs into searchable and editable text."
      },
      {
        q: "Can I make my PDF searchable?",
        a: "Yes, you can convert scanned PDFs into searchable files using this tool."
      },
      {
        q: "Does it work on scanned images?",
        a: "Yes, it recognizes text from scanned images inside PDFs."
      },
      {
        q: "Are my files stored?",
        a: "No, all files are processed securely and deleted after conversion."
      },
      {
        q: "Is it free to use?",
        a: "Yes, you can convert PDFs using OCR for free."
      },
      {
        q: "Can I upload multiple files?",
        a: "Yes, multiple PDFs can be uploaded and processed."
      },
      {
        q: "Does it support large files?",
        a: "Yes, large PDF files are supported."
      },
      {
        q: "Will formatting be preserved?",
        a: "Yes, layout and design are maintained while making text searchable."
      },
      {
        q: "Do I need to install software?",
        a: "No, the tool works completely online in your browser."
      },
      {
        q: "Can I extract text from PDF?",
        a: "Yes, you can copy and use the extracted text after conversion."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('pptx-to-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "PowerPoint to PDF",
      url,
      "Convert PowerPoint (PPT, PPTX) presentations to high-quality PDF files online for free. Fast, secure, and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Convert PowerPoint (PPTX) to PDF?",
      "Follow these 3 simple steps to convert your PowerPoint presentation into a PDF using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload your PowerPoint file (PPT or PPTX) by selecting or dragging it into the upload area."
        },
        {
          title: "Step 2: Convert to PDF",
          text: "After uploading, click on the \"Convert to PDF\" button to start the conversion process."
        },
        {
          title: "Step 3: Download PDF File",
          text: "Within seconds, your PowerPoint will be converted into a PDF. Click Download to save it."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How do I convert PowerPoint to PDF using ThePDFLeader?",
        a: "Upload your PPT/PPTX file, click convert, and download the PDF instantly."
      },
      {
        q: "Can I upload large PowerPoint files?",
        a: "Yes, the tool supports both small and large presentation files."
      },
      {
        q: "Does it work on all operating systems?",
        a: "Yes, it works on Windows, macOS, Linux, and mobile devices."
      },
      {
        q: "Do I need Microsoft Office installed?",
        a: "No, the tool works fully online without requiring Office software."
      },
      {
        q: "Is my data safe?",
        a: "Yes, files are processed securely and deleted after conversion."
      },
      {
        q: "Can I use it on mobile?",
        a: "Yes, the tool works on smartphones, tablets, and desktops."
      },
      {
        q: "Will formatting be preserved?",
        a: "Yes, layout, fonts, and images remain intact after conversion."
      },
      {
        q: "Is it free to use?",
        a: "Yes, you can convert PowerPoint to PDF for free with no restrictions."
      },
      {
        q: "Can I convert multiple files?",
        a: "Yes, you can convert multiple presentations without limits."
      },
      {
        q: "Why use ThePDFLeader PowerPoint to PDF tool?",
        a: "It is fast, secure, free, and requires no signup."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
else if (url.includes('compress-pdf')) {
  const schema = [
    this.schemaService.getSoftwareApplicationSchema(
      "Compress PDF",
      url,
      "Compress PDF files online for free and reduce file size while maintaining quality. Fast, secure, and no signup required."
    ),
    this.schemaService.getBreadcrumbSchema(url),
    this.schemaService.getHowToSchema(
      "How to Compress PDF Files to Smaller Size?",
      "Follow these 3 simple steps to reduce your PDF file size using ThePDFLeader.",
      [
        {
          title: "Step 1: Click on \"Click or drag file to upload\"",
          text: "Upload your PDF file by selecting or dragging it into the upload area. You can upload large or multiple files."
        },
        {
          title: "Step 2: Compress PDF",
          text: "After uploading, click on the \"Compress PDF\" button. The tool will reduce file size while keeping quality intact."
        },
        {
          title: "Step 3: Download Compressed PDF",
          text: "Within seconds, your compressed PDF will be ready. Click Download to save it securely."
        }
      ]
    ),
    this.schemaService.getFAQSchema([
      {
        q: "How do I compress PDF using ThePDFLeader?",
        a: "Upload your file, click compress, and download the smaller PDF instantly."
      },
      {
        q: "Can I compress large PDF files?",
        a: "Yes, large PDF files are supported and compressed efficiently."
      },
      {
        q: "Do I need to sign up?",
        a: "No, the tool works without registration."
      },
      {
        q: "Can I compress multiple PDFs at once?",
        a: "Yes, you can upload and compress multiple files together."
      },
      {
        q: "Will quality be reduced?",
        a: "No, the tool maintains content quality while reducing file size."
      },
      {
        q: "Is it safe to use?",
        a: "Yes, files are processed securely and deleted after compression."
      },
      {
        q: "Can I use it on mobile devices?",
        a: "Yes, it works on smartphones, tablets, and desktops."
      },
      {
        q: "How fast is the compression?",
        a: "Most files are compressed within a few seconds."
      },
      {
        q: "Does it support all PDF types?",
        a: "Yes, all types of PDFs including multi-page files are supported."
      },
      {
        q: "Why use ThePDFLeader PDF compressor?",
        a: "It is fast, free, secure, and maintains quality while reducing file size."
      }
    ])
  ];

  this.schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": schema
  });
}
  }
  getSchemaForPage(url: string): object {
    // Add logic to return schema dynamically based on URL
    if (url == '') {
      return {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'PDF Converter',
        url: `https://thepdfleader.com${url}`,
        applicationCategory: 'UtilityApplication',
        operatingSystem: 'All',
        offers: {
          '@type': 'Offer',
          price: '0.00',
          priceCurrency: 'USD',
          availability: 'https://schema.org/OnlineOnly',
        },
        description:
          'A tool for converting PDFs to other formats quickly and efficiently.',
      };
    } else if (url == 'pdf-merge') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'PDF Merge Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Merge PDFs online quickly and securely.',
      };
    } else if (url == 'pdf-split') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'PDF Split Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Split PDFs online quickly and securely.',
      };
    } else if (url == 'html-to-image') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Convert HTML to IMAGE Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Convert HTML to IMAGE online quickly and securely.',
      };
    } else if (url == 'pdf-to-word') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Convert PDF to WORD Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Convert PDF to WORD online quickly and securely.',
      };
    } else if (url == 'html-to-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Convert HTML to PDF Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Convert HTML to PDF online quickly and securely.',
      };
    } else if (url == 'unlock-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Unlock PDFs Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Unlock PDFs online quickly and securely.',
      };
    } else if (url == 'protect-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Protect PDFs Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Protect PDFs online quickly and securely.',
      };
    } else if (url == 'watermark-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Add Watermark to PDFs Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Add Watermark to PDFs online quickly and securely.',
      };
    } else if (url == 'pdf-to-excel') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Convert PDFs to Excel Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Convert PDFs to Excel online quickly and securely.',
      };
    } else if (url == 'word-to-png') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Word to PNG Converter – Free Online Conversion',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
          url: 'https://thepdfleader.com/',
        },
        description:
          'Convert Word (DOC, DOCX) to PNG images online for free. Secure, fast, and high-quality conversion with The PDF Leader.',
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'USD',
          category: 'Digital Service',
        },
        serviceType: 'Online File Conversion',
        areaServed: {
          '@type': 'Country',
          name: 'Worldwide',
        },
      };
    } else if (url == 'excel-to-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Convert EXCEL to PDF Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Convert EXCEL to PDF online quickly and securely.',
      };
    } else if (url == 'image-to-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Convert IMAGE to PDFs Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Convert IMAGE to PDFs online quickly and securely.',
      };
    } else if (url == 'word-to-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Convert WORD to PDFs Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description: 'Convert WORD to PDFs online quickly and securely.',
      };
    } else if (url == 'ocr-pdf-image') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Optical Charecter Recognition Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description:
          'Optical Charecter Recognition online quickly and securely.',
      };
    } else if (url == 'compress-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Compress PDF Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description:
          'Compressing PDF files to reduce their size while preserving quality and content integrity.',
      };
    } else if (url == 'pptx-to-pdf') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Convert PPTX to PDF Service',
        url: `https://thepdfleader.com/${url}`,
        provider: {
          '@type': 'Organization',
          name: 'The PDF Leader',
        },
        description:
          'Converting PowerPoint presentations (PPTX) to high-quality PDF files while preserving layout and formatting.',
      };
    } else {
      return {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'The PDF Leader',
        url: `https://thepdfleader.com/${url}`,
        description: 'Your go-to solution for PDF tools and services.',
      };
    }
  }
}
